import { toast } from 'sonner'
import { User } from '@/types/user.type'
import { useState, useEffect } from 'react'
import { fError } from '@/utils/format-error'
import axios, { endpoints } from '@/lib/axios'
import { useBoolean } from '@/hooks/use-boolean'
import { useParams } from '@/routes/hooks/use-params'
import LoadingSection from '@/components/loading-indicator/loading-section'

import ShopForm from '../shop-form'

// ----------------------------------------------------------------------

export default function ShopFormView() {
  const params = useParams()
  const loading = useBoolean(true)
  const [shop, setShop] = useState<User | undefined>(undefined)
  const isEditMode = params.id !== undefined

  const fetchShop = async () => {
    if (!isEditMode || !params.id) {
      loading.onFalse()
      return
    }

    try {
      loading.onTrue()
      const { data } = await axios.get<User>(endpoints.users.detail(params.id))
      setShop(data)
    } catch (error) {
      console.error(error)
      toast.error(fError(error))
    } finally {
      loading.onFalse()
    }
  }

  useEffect(() => {
    fetchShop()
  }, [params.id])

  return (
    <LoadingSection loading={loading.value}>
      <ShopForm shop={shop} mode={isEditMode ? 'edit' : 'create'} />
    </LoadingSection>
  )
}
